import { ColDef, ColType } from '../interfaces/colDef';

/** Intake list columns. Server-side order is newest first; no column sorts or filters. */
export const intakeStickyColumns: ColDef[] = [
  { name: 'received_at', title: 'intake.col.received', type: ColType.DATE, sort: false, filter: false, required: true, disabled: true },
];

export const intakeColumns: ColDef[] = [
  // Takes the width the other columns leave (the list sets fitWidth on the dual-axis);
  // maxWidth none lifts the grid cell's 300px cap so the cell fills that track.
  { name: 'subject', title: 'intake.col.subject', type: ColType.STRING, sort: false, filter: false, required: true,
    gridTrack: 'minmax(160px, 1fr)', style: { maxWidth: 'none' } },
  // Capped tracks so every column fits at 1280; long values ellipsize (intake-list scss).
  { name: 'sender', title: 'intake.col.from', type: ColType.STRING, sort: false, filter: false, required: false,
    gridTrack: 'minmax(140px, 220px)' },
  { name: 'verdict', title: 'intake.col.verdict', type: ColType.STRING, sort: false, filter: false, required: true },
  { name: 'reason', title: 'intake.col.reason', type: ColType.STRING, sort: false, filter: false, required: false,
    gridTrack: 'minmax(140px, 260px)' },
];
